import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon, TrashIcon } from "@heroicons/react/outline";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ApiCheckUp from "../../api/ApiCheckup";
import ApiImage from "../../api/ApiImage";
import { CheckFile, dataURLtoFile } from "../../utils";
import CSwl from "../../utils/alert";
import loadImage from "blueimp-load-image/js";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

const ExportDataCheckPage = () => {
    const { t } = useTranslation();
    const exportData = useSelector((state) => state.exportData);
    const navigate = useNavigate();
    const [checkup, setCheckup] = useState({
        masterCheckups: [],
        tranCheckups: []
    });


    useEffect(() => {
        if (checkup.masterCheckups.length == 0) {
            getCheckup();
        }
    }, [checkup]);

    const clearCheckup = () => {
        setCheckup({
            masterCheckups: [],
            tranCheckups: []
        })
    }

    const getCheckup = async () => {
        CSwl.SwalLoad();
        const response = await ApiCheckUp.getCheckupExportData(exportData.docNo,exportData.phyLocationId);
        if (response.status == 200) {
            setCheckup({
                masterCheckups: response.data.masterExportDatas,
                //tranCheckups: []
                tranCheckups: response.data.tranWhExportFiles
            });
            const responseSaveImage = await ApiImage.SaveExportData({
                file: {

                },
                data: { ...exportData }
            });
        }
        CSwl.SwalClose();
        setTimeout(() => {
            if (localStorage.getItem('scrollPosition') !== null)
                window.scrollTo(0, localStorage.getItem('scrollPosition'));
        }, 500);
    }

    const titelList = [];
    checkup.masterCheckups.map((item, index) => {
        if (titelList.indexOf(item.title) === -1) {
            titelList.push(item.title);
            return item.title;
        }
        return null;
    })

    const finishCheckup = async () => {
        //console.log("batchItems::",batchItems)
        CSwl.SwalLoad();
        try {
            const response = await ApiCheckUp.finishCheckup({
            });
            if (response.status == 200) {
                navigate('/jobTimeline');
            }
            else {
                CSwl.SwalErr(`${response.data}`);
            }

        } catch (error) {
            const { data } = error.response;
            CSwl.SwalErr(data.message)
        }
    }

    return <div className="pb-5">
        <nav class="flex bg-white text-gray border-b border-gray-200 py-3 px-5  mb-4" aria-label="Breadcrumb">
            <ol class="inline-flex items-center space-x-1 md:space-x-3">
                <li class="inline-flex items-center">
                    <Link to="/exportData" className="text-gray-700 hover:text-gray-900 inline-flex items-center">
                        {/* <svg class="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg> */}
                        {t('export.exportPhoto')}
                    </Link>
                </li>
                <li aria-current="page">
                    <div class="flex items-center">
                        <svg class="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
                        <span class="text-red  ml-1 md:ml-2 font-medium">{t('export.takePhoto')}</span>
                    </div>
                </li>
                <li aria-current="page">
                    <div class="flex items-center">
                        <svg class="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
                        <span class="text-red  ml-1 md:ml-2 font-medium">{exportData?.docNo}</span>
                    </div>
                </li>
            </ol>
        </nav>
        <div className="px-3">
            {
                titelList.map((title, index) => {
                    return (
                        <>
                            <div className="flex">
                                <h1 className="text-2xl text-red">{title}</h1>
                            </div>
                            {checkup.masterCheckups.filter(x => x.title == title).map((item, index) => {
                                return (
                                    <div>
                                        <CheckItem clearCheckup={clearCheckup} masterItem={item} key={item.id} exportData={exportData} title={item.detail} checkupId={item.id}
                                            checkupItem={checkup.tranCheckups.filter((s) => { return s.exportDataId == item.id })}
                                        />
                                    </div>
                                )
                            })
                            }
                        </>
                    )
                })
            }
            <div className="flex justify-center mt-3 gap-x-2">
                <button className="btn-blue ml-2" onClick={() => { navigate('/exportData') }}>{t('common.back')}</button>
            </div>
            {/* <div className="flex">
                <h1 className="text-2xl text-red">ตรวจสอบความพร้อมพนักงานขับรถ</h1>
            </div>
            <div>
                {checkup.masterCheckups.filter(x => x.title == "ตรวจความพร้อมพนักงานขับรถ").map((item, index) => {
                    return <CheckItem key={item.id} title={item.detail} />
                })}
            </div>
            <div className="flex mt-4">
                <h1 className="text-2xl text-red">ตรวจสภาพรถ</h1>
            </div>
            <div>
                {checkup.masterCheckups.filter(x => x.title == "ตรวจสภาพรถ").map((item, index) => {
                    return <CheckItem key={item.id} title={item.detail} />
                })}
            </div>
            <div className="flex mt-4">
                <h1 className="text-2xl text-red">อุปกรณ์ Safety</h1>
            </div>
            <div>
                {checkup.masterCheckups.filter(x => x.title == "อุปกรณ์ Safety").map((item, index) => {
                    return <CheckItem key={item.id} title={item.detail} />
                })}
            </div> */}
        </div>
    </div>
}

const CheckItem = ({ title, checkupId, checkupItem, exportData, masterItem, clearCheckup }) => {
    const { t } = useTranslation();
    const [photosDefault, setphotos] = useState(checkupItem);
    const navigate = useNavigate();
    const [file, setfile] = useState("");
    const [productType, setProductType] = useState("floor");
    const [placementType, setPlacementType] = useState("stack");
    const [layoutType, setLayoutType] = useState("marked");
    const [positions, setPositions] = useState([
        { position: 1, positionStack: 1, rollNo: 1, isStack: "N", positionName: "1,1" }
    ]);
    const [rollCounter, setRollCounter] = useState(1);
    const [pendingMeta, setPendingMeta] = useState(null);
    const fileInputRef = useRef(null);
    const isPositionOne = (title || "").toLowerCase().includes("3.2 ภาพถ่ายสินค้าในตู้");
    const showOption = (masterItem?.iS_SHOW_OPTION === "Y" || masterItem?.iS_SHOW_OPTION === 1 || masterItem?.iS_SHOW_OPTION === true);
    const resetPositions = () => {
        setPositions([{ position: 1, positionStack: 1, rollNo: 1, isStack: "N", positionName: "1,1" }]);
        setRollCounter(1);
    };

    const addNextPosition = () => {
        const nextPosition = positions.length === 0 ? 1 : Math.max(...positions.map(p => p.position)) + 1;
        const nextRoll = rollCounter + 1;
        setPositions([
            ...positions,
            { position: nextPosition, positionStack: 1, rollNo: nextRoll, isStack: "N", positionName: `${nextPosition},1` }
        ]);
        setRollCounter(nextRoll);
    };

    const addStack = (basePosition) => {
        const stacksInPosition = positions.filter(p => p.position === basePosition);
        const nextStack = stacksInPosition.length === 0 ? 1 : Math.max(...stacksInPosition.map(p => p.positionStack)) + 1;
        const nextRoll = rollCounter + 1;
        setPositions([
            ...positions,
            { position: basePosition, positionStack: nextStack, rollNo: nextRoll, isStack: "Y", positionName: `${basePosition},${nextStack}` }
        ]);
        setRollCounter(nextRoll);
    };

    const removeRoll = (rollNo) => {
        const updated = positions.filter((p) => p.rollNo !== rollNo);
        if (updated.length === 0) {
            setPositions([{ position: 1, positionStack: 1, rollNo: 1, isStack: "N", positionName: "1,1" }]);
            setRollCounter(1);
        } else {
            setPositions(updated);
            setRollCounter(Math.max(...updated.map((p) => p.rollNo)));
        }
    };

    const photosByPosition = (meta) => {
        if (!meta) return [];
        return photosDefault.filter((p) => {
            const pos = p.position ?? p.exportDataIdPosition ?? p.exportdataidposition;
            const stack = p.positionStack ?? p.exportDataIdPositionStack ?? p.exportdataidpositionstack;
            return `${pos}` === `${meta.position}` && `${stack}` === `${meta.positionStack}`;
        });
    };

    const canAddNextPosition = (posNumber) => {
        const stacks = positions.filter((p) => p.position === posNumber);
        return stacks.some((stack) => photosByPosition(stack).length > 0);
    };

    const derivePositionsFromPhotos = () => {
        const combos = new Map();
        photosDefault.forEach((item) => {
            const pos = item.position ?? item.exportDataIdPosition ?? item.exportdataidposition;
            const stack = item.positionStack ?? item.exportDataIdPositionStack ?? item.exportdataidpositionstack;
            if (pos === undefined || stack === undefined) return;
            const key = `${pos}-${stack}`;
            if (!combos.has(key)) {
                const roll = item.rollNo ?? item.rollno;
                combos.set(key, {
                    position: Number(pos),
                    positionStack: Number(stack),
                    rollNo: roll,
                    isStack: Number(stack) > 1 ? "Y" : "N",
                    positionName: `${pos},${stack}`
                });
            }
        });
        const derived = Array.from(combos.values()).sort((a, b) => {
            if (a.position === b.position) return a.positionStack - b.positionStack;
            return a.position - b.position;
        });
        const withRoll = derived.map((p, idx) => ({
            ...p,
            rollNo: p.rollNo ?? idx + 1
        }));
        if (withRoll.length > 0) {
            setPositions(withRoll);
            setRollCounter(Math.max(...withRoll.map((p) => p.rollNo)));
        }
    };



    useEffect(() => {
        if (layoutType === "marked") {
            resetPositions();
        }
    }, [layoutType]);

    useEffect(() => {
        if (layoutType === "marked" && photosDefault && photosDefault.length > 0) {
            derivePositionsFromPhotos();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [layoutType, photosDefault]);

    const triggerUpload = (meta = null) => {
        setPendingMeta(meta);
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const uploadFile = async (e, meta = null) => {
        //alert(masterItem.maxPhoto)
        if (photosDefault.length == (masterItem.maxPhoto)) {
            CSwl.SwalErr(t('job.canUploadMaxPhotos', { count: masterItem.maxPhoto }));
            return false;
        }
        let imageResponse = [];
        if (e.target.files.length > 0) {
            for (let i = 0; i < e.target.files.length; i++) {
                const file = e.target.files[i];
                if (
                    await CheckFile({ file: file, size: 10, type: ['image/gif', 'image/jpeg', 'image/png'] })) {
                    CSwl.SwalLoad();
                    const loadImageResponse = await loadImage(
                        file,
                        async img => {
                            var base64data = img.toDataURL(`image/jpeg`);
                            // Extract number from masterItem.detail (e.g., "1.2" from "1.2 Preparedness at picking area")
                            const numberMatch = masterItem.detail.match(/^[\d.]+/);
                            const numberPart = numberMatch ? numberMatch[0].replace(/\./g, '_') : 'image';
                            const currentIndex = photosDefault.length + i + 1;
                            const metaPart = meta ? `_${meta.position}_${meta.positionStack}` : "";
                            const customFileName = `${numberPart}_${currentIndex}_${exportData.docNo}${metaPart}_${Date.now()}.jpg`;
                            var fileNew = dataURLtoFile(base64data, customFileName);
                            //setfile(fileNew);
                            console.log('meta::', meta);
                            const responseupload = await uploadFileApi(fileNew, meta);
                            imageResponse.push(responseupload);
                            e.target.value = null;

                            if (imageResponse.length == (i + 1)) {
                                clearCheckup();
                            }
                            return responseupload;
                        },
                        { orientation: true, canvas: true }
                    );
                    //setfile(image);
                    CSwl.SwalClose();
                }

            }
        }
    }

    const uploadFileApi = async (file, meta = null) => {
        localStorage.setItem('scrollPosition', window.scrollY);
        const response = await ApiImage.uploadImageExportData(file);
        if (response.status == 200) {
            const responseSaveImage = await ApiImage.SaveExportDataImage({
                file: {
                    exportDataId: checkupId,
                    "photoName": response.data.filename,
                    "photoThumbnailName": response.data.thumbnainlname,
                    productType: productType,
                    placementType: placementType,
                    layoutType: layoutType,
                    ...(meta ? {
                        position: meta.position,
                        positionStack: meta.positionStack,
                        rollNo: meta.rollNo,
                        isStack: meta.isStack,
                        positionName: meta.positionName
                    } : {})
                },
                data: { ...exportData, exportDataId: checkupId }
            });
            if (responseSaveImage.status == 200) {

                setphotos([...photosDefault,
                {
                    id: responseSaveImage.data.imgid,
                    photoThumbnailName: responseSaveImage.data.thumbnailName,
                    checkupId: checkupId
                }])
                return responseSaveImage.status;
            }
        }
    }



    const deleteImage = async (id) => {
        CSwl.SwalLoad();

        const response = await ApiImage.deleteImageWhExport(id);
        if (response.status == 200) {
            setphotos(photosDefault.filter(x => x.id != id))
            CSwl.SwalClose();
        }
        else {
            CSwl.SwalClose();
        }
    }



    return <Disclosure defaultOpen>
        {({ open }) => (
            <>
                <Disclosure.Button className={`flex w-full justify-between 
            ${open ? 'rounded-bl-none rounded-br-none ' : ''}
            border border-gray-200 px-4 py-2 text-left text-sm font-medium focus:outline-none focus-visible:ring focus-visible:ring-red-500 focus-visible:ring-opacity-75`}>
                    <span className="text-bold">{title}</span>
                    <ChevronDownIcon
                        className={`${open ? 'rotate-180 transform' : ''
                            } h-5 w-5 text-purple-500`}
                    />
                </Disclosure.Button>
                <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500 border border-gray-200 rounded-br-lg rounded-bl-lg gap-y-2 flex flex-col">
                    {showOption && (
                        <div className="flex flex-col gap-3">
                            <div className="flex flex-col gap-1">
                                <span className="text-blue font-semibold">{t('export.productType')}</span>
                                <div className="flex flex-wrap gap-4">
                                    <label className="flex items-center gap-2">
                                        <input type="radio" name={`productType-${checkupId}`} value="pallet" checked={productType === "pallet"} onChange={() => setProductType("pallet")} />
                                        <span>{t('export.onPallet')}</span>
                                    </label>
                                    <label className="flex items-center gap-2">
                                        <input type="radio" name={`productType-${checkupId}`} value="floor" checked={productType === "floor"} onChange={() => setProductType("floor")} />
                                        <span>{t('export.onFloor')}</span>
                                    </label>
                                    <label className="flex items-center gap-2">
                                        <input type="radio" name={`productType-${checkupId}`} value="other" checked={productType === "other"} onChange={() => setProductType("other")} />
                                        <span>{t('export.otherProduct')}</span>
                                    </label>
                                </div>
                            </div>
                            <div className="flex flex-col gap-1">
                                <span className="text-blue font-semibold">{t('export.placementType')}</span>
                                <div className="flex flex-wrap gap-4">
                                    <label className="flex items-center gap-2">
                                        <input type="radio" name={`placementType-${checkupId}`} value="stack" checked={placementType === "stack"} onChange={() => setPlacementType("stack")} />
                                        <span>{t('export.stackPlacement')}</span>
                                    </label>
                                    <label className="flex items-center gap-2">
                                        <input type="radio" name={`placementType-${checkupId}`} value="lay" checked={placementType === "lay"} onChange={() => setPlacementType("lay")} />
                                        <span>{t('export.layPlacement')}</span>
                                    </label>
                                </div>
                            </div>
                            <div className="flex flex-col gap-1">
                                <span className="text-blue font-semibold">{t('export.layoutType')}</span>
                                <div className="flex flex-wrap gap-4">
                                    <label className="flex items-center gap-2">
                                        <input type="radio" name={`layoutType-${checkupId}`} value="marked" checked={layoutType === "marked"} onChange={() => setLayoutType("marked")} />
                                        <span>{t('export.markPosition')}</span>
                                    </label>
                                    <label className="flex items-center gap-2">
                                        <input type="radio" name={`layoutType-${checkupId}`} value="unmarked" checked={layoutType === "unmarked"} onChange={() => setLayoutType("unmarked")} />
                                        <span>{t('export.unmarkPosition')}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    )}
                    {showOption && layoutType === "marked" ? (
                        <div className="flex flex-col gap-4">
                            {
                                Array.from(
                                    positions.reduce((map, pos) => {
                                        const arr = map.get(pos.position) || [];
                                        arr.push(pos);
                                        map.set(pos.position, arr);
                                        return map;
                                    }, new Map())
                                )
                                    .sort((a, b) => a[0] - b[0])
                                    .map(([posNumber, stacks]) => {
                                        const canAddNext = canAddNextPosition(posNumber);
                                        return (
                                        <div key={`pos-${posNumber}`} className="border border-blue rounded-xl p-3 shadow-sm bg-white flex flex-col gap-3">
                                            <div className="flex flex-col gap-2">
                                                {[...stacks].sort((a, b) => b.rollNo - a.rollNo).map((stack) => (
                                                    <div key={`${stack.position}-${stack.positionStack}`} className="flex flex-col gap-1">
                                                        <div
                                                            className="w-full bg-blue text-white rounded-lg py-4 text-center text-xl font-semibold cursor-pointer"
                                                            onClick={() => triggerUpload(stack)}
                                                        >
                                                            {t('export.rollNo', { no: stack.rollNo })}
                                                        </div>

                                                        <div className="flex flex-wrap gap-2 mt-2">
                                                            {photosByPosition(stack).map((item) => (
                                                                <div key={item.id} className="relative min-w-[100px] max-w-[100px]">
                                                                    <img src={process.env.REACT_APP_IMAGE + item.photoThumbnailName} />
                                                                    <div onClick={() => deleteImage(item.id)} className="p-2 cursor-pointer absolute top-0 right-0 bg-white border border-[#cfcfcf]">
                                                                        <TrashIcon className="h-5 w-5 text-red" />
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="flex gap-2 justify-center">
                                                <button type="button" className="btn-gray px-4" onClick={() => addStack(posNumber)}>ยกซ้อน</button>
                                                <button
                                                    type="button"
                                                    className={`btn-blue px-4 ${canAddNext ? "" : "opacity-50 cursor-not-allowed"}`}
                                                    onClick={() => {
                                                        if (!canAddNext) return;
                                                        addNextPosition();
                                                    }}
                                                    disabled={!canAddNext}
                                                >
                                                    ตำแหน่งถัดไป
                                                </button>
                                            </div>
                                        </div>
                                    )})
                            }
                            <input
                                ref={fileInputRef}
                                multiple
                                onClick={(e) => { e.target.value = null; }}
                                onChange={(e) => uploadFile(e, pendingMeta)}
                                type="file"
                                className="hidden"
                            />
                           
                        </div>
                    ) : (
                        <>
                            <div class="flex w-full items-center justify-center bg-grey-lighter">
                                <label class="w-full flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-blue hover:text-white">
                                    <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                        <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                                    </svg>
                                    {file ? <>
                                        <span class="mt-2 text-base leading-normal">Upload a file ({file.name})</span>
                                        <span class="text-sm text-gray">PNG, JPG, GIF up to 10MB</span>
                                    </> : <>
                                        <span class="mt-2 text-base leading-normal">Upload a file</span>
                                        <span class="text-sm text-gray">PNG, JPG, GIF up to 10MB</span>
                                    </>}

                                    <input multiple onClick={(e) => {
                                        e.target.value = null;
                                    }} onChange={(e) => {
                                        uploadFile(e)
                                    }} type='file' class="hidden" ref={fileInputRef} />
                                </label>
                            </div>
                            <div class="flex w-full items-center justify-center bg-grey-lighter flex flex-wrap gap-2">
                                {
                                    photosDefault.map((item, index) => {
                                        return <div className="relative min-w-[100px] max-w-[100px]">
                                            <img src={process.env.REACT_APP_IMAGE + item.photoThumbnailName} />
                                            <div onClick={() => {
                                                deleteImage(item.id)
                                            }} className="p-2 cursor-pointer absolute top-0 right-0 bg-white border border-[#cfcfcf]">
                                                <TrashIcon
                                                    className={`h-5 w-5 text-red`}
                                                />
                                            </div>
                                        </div>
                                    })
                                }

                            </div>
                        </>
                    )}
                </Disclosure.Panel>
            </>
        )}
    </Disclosure>
}

const Check1 = () => {
    return <Disclosure>
        {({ open }) => (
            <>
                <Disclosure.Button className={`flex w-full justify-between 
            ${open ? 'rounded-bl-none rounded-br-none ' : ''}
            border border-gray-200 px-4 py-2 text-left text-sm font-medium focus:outline-none focus-visible:ring focus-visible:ring-red-500 focus-visible:ring-opacity-75`}>
                    <span className="text-bold">แฟ้มใส่เอกสาร/สมุดประจำตัวรถ</span>
                    <ChevronDownIcon
                        className={`${open ? 'rotate-180 transform' : ''
                            } h-5 w-5 text-purple-500`}
                    />
                </Disclosure.Button>
                <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500 border border-gray-200 rounded-br-lg rounded-bl-lg">
                    <div class="flex w-full items-center justify-center bg-grey-lighter">
                        <label class="w-full flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-blue hover:text-white">
                            <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                            </svg>
                            <span class="mt-2 text-base leading-normal">Upload a file</span>
                            <span class="text-sm text-gray">PNG, JPG, GIF up to 10MB</span>
                            <input type='file' class="hidden" />
                        </label>
                    </div>
                </Disclosure.Panel>
            </>
        )}
    </Disclosure>
}

const Check2 = () => {
    return <Disclosure>
        {({ open }) => (
            <>
                <Disclosure.Button className={`flex w-full justify-between 
            ${open ? 'rounded-bl-none rounded-br-none ' : ''}
            border border-gray-200 px-4 py-2 text-left text-sm font-medium focus:outline-none focus-visible:ring focus-visible:ring-red-500 focus-visible:ring-opacity-75`}>
                    <span className="text-bold">เครื่องแบบพขร. (เสื้อ,กางเกงขายาว,รองเท้าหุ้มส้น)</span>
                    <ChevronDownIcon
                        className={`${open ? 'rotate-180 transform' : ''
                            } h-5 w-5 text-purple-500`}
                    />
                </Disclosure.Button>
                <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500 border border-gray-200 rounded-br-lg rounded-bl-lg">
                    <div class="flex w-full items-center justify-center bg-grey-lighter">
                        <label class="w-full flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-blue hover:text-white">
                            <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                            </svg>
                            <span class="mt-2 text-base leading-normal">Upload a file</span>
                            <span class="text-sm text-gray">PNG, JPG, GIF up to 10MB</span>
                            <input type='file' class="hidden" />
                        </label>
                    </div>
                </Disclosure.Panel>
            </>
        )}
    </Disclosure>
}

const Check3 = () => {
    return <Disclosure>
        {({ open }) => (
            <>
                <Disclosure.Button className={`flex w-full justify-between 
            ${open ? 'rounded-bl-none rounded-br-none ' : ''}
            border border-gray-200 px-4 py-2 text-left text-sm font-medium focus:outline-none focus-visible:ring focus-visible:ring-red-500 focus-visible:ring-opacity-75`}>
                    <span className="text-bold">
                        อุปกรณ์PPE (เสื้อสะท้อนแสง,หมวกเซฟตี้,รองเท้าเซฟตี้)
                    </span>
                    <ChevronDownIcon
                        className={`${open ? 'rotate-180 transform' : ''
                            } h-5 w-5 text-purple-500`}
                    />
                </Disclosure.Button>
                <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500 border border-gray-200 rounded-br-lg rounded-bl-lg">
                    <div class="flex w-full items-center justify-center bg-grey-lighter">
                        <label class="w-full flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-blue hover:text-white">
                            <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                            </svg>
                            <span class="mt-2 text-base leading-normal">Upload a file</span>
                            <span class="text-sm text-gray">PNG, JPG, GIF up to 10MB</span>
                            <input type='file' class="hidden" />
                        </label>
                    </div>
                </Disclosure.Panel>
            </>
        )}
    </Disclosure>
}

const Check4 = () => {
    return <Disclosure>
        {({ open }) => (
            <>
                <Disclosure.Button className={`flex w-full justify-between 
            ${open ? 'rounded-bl-none rounded-br-none ' : ''}
            border border-gray-200 px-4 py-2 text-left text-sm font-medium focus:outline-none focus-visible:ring focus-visible:ring-red-500 focus-visible:ring-opacity-75`}>
                    <span className="text-bold">
                        พื้นบรรทุกต้องสะอาด,ไม่เปียก,ไม่มีรอยแตกรั่ว
                    </span>
                    <ChevronDownIcon
                        className={`${open ? 'rotate-180 transform' : ''
                            } h-5 w-5 text-purple-500`}
                    />
                </Disclosure.Button>
                <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500 border border-gray-200 rounded-br-lg rounded-bl-lg">
                    <div class="flex w-full items-center justify-center bg-grey-lighter">
                        <label class="w-full flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-blue hover:text-white">
                            <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                            </svg>
                            <span class="mt-2 text-base leading-normal">Upload a file</span>
                            <span class="text-sm text-gray">PNG, JPG, GIF up to 10MB</span>
                            <input type='file' class="hidden" />
                        </label>
                    </div>
                </Disclosure.Panel>
            </>
        )}
    </Disclosure>
}

const Check5 = () => {
    return <Disclosure>
        {({ open }) => (
            <>
                <Disclosure.Button className={`flex w-full justify-between 
            ${open ? 'rounded-bl-none rounded-br-none ' : ''}
            border border-gray-200 px-4 py-2 text-left text-sm font-medium focus:outline-none focus-visible:ring focus-visible:ring-red-500 focus-visible:ring-opacity-75`}>
                    <span className="text-bold">
                        สภาพยางรถ และล้อ
                    </span>
                    <ChevronDownIcon
                        className={`${open ? 'rotate-180 transform' : ''
                            } h-5 w-5 text-purple-500`}
                    />
                </Disclosure.Button>
                <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500 border border-gray-200 rounded-br-lg rounded-bl-lg">
                    <div class="flex w-full items-center justify-center bg-grey-lighter">
                        <label class="w-full flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-blue hover:text-white">
                            <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                            </svg>
                            <span class="mt-2 text-base leading-normal">Upload a file</span>
                            <span class="text-sm text-gray">PNG, JPG, GIF up to 10MB</span>
                            <input type='file' class="hidden" />
                        </label>
                    </div>
                </Disclosure.Panel>
            </>
        )}
    </Disclosure>
}

const Check6 = () => {
    return <Disclosure>
        {({ open }) => (
            <>
                <Disclosure.Button className={`flex w-full justify-between 
            ${open ? 'rounded-bl-none rounded-br-none ' : ''}
            border border-gray-200 px-4 py-2 text-left text-sm font-medium focus:outline-none focus-visible:ring focus-visible:ring-red-500 focus-visible:ring-opacity-75`}>
                    <span className="text-bold">
                        เชือก สเตย์ รัดผ้าใบ
                    </span>
                    <ChevronDownIcon
                        className={`${open ? 'rotate-180 transform' : ''
                            } h-5 w-5 text-purple-500`}
                    />
                </Disclosure.Button>
                <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500 border border-gray-200 rounded-br-lg rounded-bl-lg">
                    <div class="flex w-full items-center justify-center bg-grey-lighter">
                        <label class="w-full flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-blue hover:text-white">
                            <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                            </svg>
                            <span class="mt-2 text-base leading-normal">Upload a file</span>
                            <span class="text-sm text-gray">PNG, JPG, GIF up to 10MB</span>
                            <input type='file' class="hidden" />
                        </label>
                    </div>
                </Disclosure.Panel>
            </>
        )}
    </Disclosure>
}

const Check7 = () => {
    return <Disclosure>
        {({ open }) => (
            <>
                <Disclosure.Button className={`flex w-full justify-between 
            ${open ? 'rounded-bl-none rounded-br-none ' : ''}
            border border-gray-200 px-4 py-2 text-left text-sm font-medium focus:outline-none focus-visible:ring focus-visible:ring-red-500 focus-visible:ring-opacity-75`}>
                    <span className="text-bold">
                        ลิ่มรองล้อ พลาสติก
                    </span>
                    <ChevronDownIcon
                        className={`${open ? 'rotate-180 transform' : ''
                            } h-5 w-5 text-purple-500`}
                    />
                </Disclosure.Button>
                <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500 border border-gray-200 rounded-br-lg rounded-bl-lg">
                    <div class="flex w-full items-center justify-center bg-grey-lighter">
                        <label class="w-full flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-blue hover:text-white">
                            <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                            </svg>
                            <span class="mt-2 text-base leading-normal">Upload a file</span>
                            <span class="text-sm text-gray">PNG, JPG, GIF up to 10MB</span>
                            <input type='file' class="hidden" />
                        </label>
                    </div>
                </Disclosure.Panel>
            </>
        )}
    </Disclosure>
}

const Check8 = () => {
    return <Disclosure>
        {({ open }) => (
            <>
                <Disclosure.Button className={`flex w-full justify-between 
            ${open ? 'rounded-bl-none rounded-br-none ' : ''}
            border border-gray-200 px-4 py-2 text-left text-sm font-medium focus:outline-none focus-visible:ring focus-visible:ring-red-500 focus-visible:ring-opacity-75`}>
                    <span className="text-bold">
                        กล้องหน้ารถ พร้อมใช้งาน
                    </span>
                    <ChevronDownIcon
                        className={`${open ? 'rotate-180 transform' : ''
                            } h-5 w-5 text-purple-500`}
                    />
                </Disclosure.Button>
                <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500 border border-gray-200 rounded-br-lg rounded-bl-lg">
                    <div class="flex w-full items-center justify-center bg-grey-lighter">
                        <label class="w-full flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-blue hover:text-white">
                            <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                            </svg>
                            <span class="mt-2 text-base leading-normal">Upload a file</span>
                            <span class="text-sm text-gray">PNG, JPG, GIF up to 10MB</span>
                            <input type='file' class="hidden" />
                        </label>
                    </div>
                </Disclosure.Panel>
            </>
        )}
    </Disclosure>
}

export default ExportDataCheckPage;